import { takeEvery } from 'redux-saga/effects';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import { Notify } from '@flexisaf/flexibull2';
import request from 'utils/request';
import urls from 'utils/config';
import ApplicantsActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* changeApplicantStage({
  payload: { candidate, status, cb },
}) {
  const { id, comment, locationId } = candidate;
  const url = `${API_BASE_URL}/candidates/${id}`;
  const formData = {
    stageId: status,
    locationId
  };
  if (comment) {
    formData.reason = comment
  }
  const response = yield request({
    method: 'patch',
    data: formData,
    url,
  });
  if (response.success) {
    if (cb && typeof cb === 'function') {
      cb();
    }
    Notify('Applicant stage updated successfully', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
  } else {
    networkErrorHandler(response?.statusCode, response?.message);
  }
}

export function* onChangeApplicantStage() {
  yield takeEvery(
    ApplicantsActionTypes.PROCESS_APPLICANT_STAGE,
    changeApplicantStage
  );
}
